import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './emoji.module.scss';

const Emoji = (props) => {
  const { className, label, symbol } = props;

  return (
    <span
      className={classnames(className, styles.emoji)}
      role="img"
      aria-label={label ? label : null}
      aria-hidden={label ? false : true}
    >
      {symbol}
    </span>
  );
};

Emoji.propTypes = {
  symbol: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default Emoji;
